// src/utils/fileHelpers.js
import {
    ALLOWED_AVATAR_EXTENSIONS,
    ALLOWED_AVATAR_MIME_TYPES,
    MAX_AVATAR_SIZE
} from '../utils/constants';
// Проверка, что файл — валидный аватар
export const isValidAvatarFile = (file) => {
    if (!file) return false;

    const ext = file.name.split('.').pop().toLowerCase();
    if (!ALLOWED_AVATAR_EXTENSIONS.includes(ext)) return false;

    // MIME-тип может быть пустым в некоторых браузерах, поэтому проверяем опционально
    if (file.type && !ALLOWED_AVATAR_MIME_TYPES.includes(file.type)) return false;  
    
    if (file.size > MAX_AVATAR_SIZE) return false;

    return true;
};

// Получить понятное сообщение об ошибке
export const getAvatarErrorMessage = (file) => {
    if (!file) return 'Файл не выбран';

    const ext = file.name.split('.').pop().toLowerCase();
    if (!ALLOWED_AVATAR_EXTENSIONS.includes(ext)) {
        return `Недопустимый формат. Разрешены: ${ALLOWED_AVATAR_EXTENSIONS.join(', ')}`;
    }

    
    if (file.size > MAX_AVATAR_SIZE) {
        return 'Файл слишком большой. Максимум 5 МБ';
    }

    return 'Недопустимый файл';
};
// Иконка для типа файла
export const getFileIcon = (fileName) => {
    if (!fileName || typeof fileName !== 'string') return 'bi-file-earmark';
    const ext = fileName.split('.').pop().toLowerCase() || '';
    const icons = {
        'pdf': 'bi-file-pdf',
        'doc': 'bi-file-word', 'docx': 'bi-file-word',
        'xls': 'bi-file-excel', 'xlsx': 'bi-file-excel',
        'ppt': 'bi-file-slides', 'pptx': 'bi-file-slides',
        'jpg': 'bi-file-image', 'jpeg': 'bi-file-image', 'png': 'bi-file-image', 
        'gif': 'bi-file-image', 'webp': 'bi-file-image','svg': 'bi-file-image',
        'mp4': 'bi-camera-video', 'avi': 'bi-file-play', 'mov': 'bi-file-play', 'mkv': 'bi-file-play', 'webm': 'bi-mic',
        'mp3': 'bi-file-music', 'wav': 'bi-file-music', 'flac': 'bi-file-music',
        'zip': 'bi-file-zip', 'rar': 'bi-file-zip', '7z': 'bi-file-zip',
        'txt': 'bi-file-text',
        'json': 'bi-file-code', 'xml': 'bi-file-code', 'html': 'bi-file-code',
        'js': 'bi-file-code', 'css': 'bi-file-code', 'ts': 'bi-file-code',
    };
    return icons[ext] || 'bi-file-earmark';
};
// Обрезка длинного имени файла
export const truncateFileName = (name, maxLen = 30) => {
    if (!name) return 'Файл';  
    const dotIndex = name.lastIndexOf('.');
    if (dotIndex === -1) {
        return name.length > maxLen ? name.substring(0, maxLen - 3) + '...' : name;
    }
      const ext = name.substring(dotIndex-5);
      const baseName = name.substring(0, dotIndex);
      if (baseName.length <= maxLen) return name;
      return baseName.substring(0, maxLen - 3) + '...' + ext;
};
// Извлечение ссылок из текста
export const extractUrls = (text) => {
     if (!text || typeof text !== 'string') return [];
    const urlRegex = /https?:\/\/[^\s/$.?#].[^\s]*/gi;
    return text.match(urlRegex) || [];
};
// Удаление ссылок из текста
export const removeUrls = (text) => {
    if (!text) return '';
    return text.replace(/(https?:\/\/[^\s]+)/g, '').trim();
};
